import { useState } from 'react';

/** Number of categories shown in the mobile grid before "View All" is needed. */
export const COLLAPSED_CATEGORY_COUNT = 6;

type UseListReturn = {
  isExpanded: boolean;
  viewAllItems: () => void;
};

export const useList = (): UseListReturn => {
  const [isExpanded, setIsExpanded] = useState(false);

  const viewAllItems = (): void => {
    setIsExpanded(true);
  };

  return {
    isExpanded,
    viewAllItems,
  };
};
